import { render, staticRenderFns } from "./PersonProfileMasterAddNote.vue?vue&type=template&id=1bc0a22e&scoped=true&"
import script from "./PersonProfileMasterAddNote.vue?vue&type=script&lang=js&"
export * from "./PersonProfileMasterAddNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc0a22e",
  null
  
)

export default component.exports